import React from 'react';

import Layout from '../../../components/Layout/Layout';
import LearningCenterLayout from '../../../components/LearningCenterLayout/LearningCenterLayout';
import LearningCenterSubnav from '../../../components/LearningCenterSubnav/LearningCenterSubnav';
import { withD } from '../../../util/withDynamicThing';
import { buildSearchPage } from '../buildSearchPage';

const { getServerSideProps, Page } = buildSearchPage({
    site: 'LEARN',
    basePath: '/learn',
    LayoutComponent: (props: {
        menu?: unknown;
        head: string;
        children: React.ReactNode;
        preview?: boolean;
    }) => (
        <LearningCenterLayout>
            <Layout {...props} NavComponent={LearningCenterSubnav} />
        </LearningCenterLayout>
    ),
});

export { getServerSideProps };

const C = await withD(Page);

export default C;
